<div class="block-small" [ngClass]='{"cursor-pointer": hasLink || hasExternalLink}' (click)="onClick()">
    <div class="banner-left" [ngStyle]="{'background-image': 'url(' + image + '), url(\'/assets/images/no-image-placeholder.png\')'}">
      <div class="content">
      </div>
    </div>
    <div class="block-small_content">
        <h3>{{title}}</h3>
        <h4 *ngIf="hasSubtitle" class="d-none d-lg-block">
            {{subtitle}}
        </h4>
      <span *ngIf="content" class="d-none d-lg-block">{{ content }}</span>
    </div>
</div>
